export type AuthUser = {
  id: string;
  email: string;
  role: "admin" | "manager" | "mechanic";
  branchId?: string | null;
  branch?: { id: string; name: string } | null;
  fullName?: string | null;
};

/** Map role → default landing page after login. */
export function landingPathForRole(role: AuthUser["role"]): string {
  switch (role) {
    case "mechanic":
      return "/work";
    case "manager":
      return "/diagnostics";
    case "admin":
      return "/admin/users";
  }
}
